export default {"src":"/_next/static/media/ZYXI.4edbf275.svg","height":18,"width":18};